export default __webpack_public_path__ + "static/media/building_snow_original.75346606.jpeg";